/**
 * `core/lenis/lenis.js`
 *  - 慣性スクロール lenis.js
 *
 * 使用方法:
 *  - import {initLenis, resetLenis} from "./core/lenis/lenis.js";
 *  - スクロールハイジャックを使用するLocomotiveScrollやGsapScrollSmootherとは異なり、
 *  - Lenisはブラウザネイティブスクロールを使用しているため、Webサイトのページ間で更新/リフレッシュする必要がありません。
 *  - そのため、momentumScrollを介さず、initBarba() の手前で initLenis() を実行するだけで正常に動きますが、
 *  - 現状は便宜上momentumScrollに組み込んでいます。
 */


import Lenis from "lenis";
import {config} from "../../../config.js";

export let lenis = null;

/**
 * Lenis の初期化
 */
export function initLenis() {

  lenis = getLenisInstance();

  if (!lenis) {
    console.log("✨ Initializing Lenis...");

    lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false,
      syncTouch: true,
      autoResize: true, // ✅ 自動的に高さを更新する
      anchors: true, // ✅ アンカーリンクを適切に処理
    });

    if (!config.useGsapScrollTrigger) {
      // requestAnimationFrame を一度だけ設定
      const loop = (time) => {
        lenis.raf(time);
        requestAnimationFrame(loop);
      };
      requestAnimationFrame(loop);
    }
  }

}

// ページ遷移時のリセットは不要
export function resetLenis() {
  console.log("🔄 Lenis reset not required (using native scrolling)");
}

// Lenis の状態を取得
export function getLenisInstance() {
  return lenis;
}